module.exports = {"id":"193296","name":"Ruud Boymans","rating":"72","photo":"./data/images/photos/0/193296.png","club":{"name":"FC Utrecht","logo":"./data/images/clubs/FCUtrecht.png"},"positions":["BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RuudBoymans0.json
// module id = 3750
// module chunks = 0